function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DA251d",
  d: "M-20-15h40v30h-40z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "b",
  transform: "translate(0 -6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "a",
  fill: "#FF0",
  transform: "rotate(18)",
  d: "M0 0v6h4"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  transform: "scale(-1 1)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "c",
  transform: "rotate(72)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  transform: "rotate(72)"
}));

var _ref5 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  transform: "scale(-1 1)"
});

function SvgVn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-15 -10 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVn);
export default __webpack_public_path__ + "static/media/vn.ba3a22e4.svg";
export { ForwardRef as ReactComponent };